import { Cell, Wrapper } from './Time.styled'

type TimeProps = {
    onClick: () => void;
    cells: string[],
    className?: string,
    style?: React.CSSProperties,
    delegated?: React.HTMLAttributes<HTMLDivElement>,
};

const Time: React.FC<TimeProps> = ({ onClick, cells, className = "", style = {}, ...delegated }) => {
    return (
        <Wrapper className={className} style={style} {...delegated}>
            {cells.map(c => (
                <Cell onClick={onClick}>{c}</Cell>)
            )}
        </Wrapper>
    )
}

export default Time